export const getDateWithoutSeconds = (date: any) => {
  const dateWithoutSecond = new Date(date).toLocaleTimeString([], {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return dateWithoutSecond;
};
